import { createSelector } from 'reselect';
import { RootReducerInterface } from '../interfaces/RootReducerInterface';

// Base selectors
// const selectState = (state: RootReducerInterface) => state;
const selectSettings = (state: RootReducerInterface) => state.settings;
const selectWorkspace = (state: RootReducerInterface) => state.workspace;
const selectCustomer = (state: RootReducerInterface) => state.customer;
const selectTimeTracking = (state: RootReducerInterface) => state.timeTracking;

// Memoized selectors
export const selectThemeMode = createSelector([selectSettings], (settings) => settings?.themeMode);

export const selectThemeType = createSelector([selectSettings], (settings) => settings?.themeType);

export const selectWorkspaceData = createSelector([selectWorkspace], (workspace) => workspace?.workspace);

// New selectors for CustomerModal
export const selectNewCustomer = createSelector([selectCustomer], (customer) => customer?.newCustomer);

// New selectors for AddNewTimeModal
export const selectTimeTrackingState = createSelector(
  [selectTimeTracking, selectWorkspace],
  (timeTracking, workspace) => ({
    currentTimeTracking: timeTracking?.currentTimeTracking,
    timeEntryInput: timeTracking?.timeEntryInput,
    listDropdown: timeTracking?.listDropdown,
    workspace: workspace?.workspace
  })
);

// New selectors for Tasks
export const selectTasksState = createSelector([selectWorkspace, selectSettings], (workspace, settings) => ({
  workspace: workspace?.workspace,
  themeMode: settings?.themeMode
}));

// New selectors for SettingNavbar
export const selectSettingNavbarState = createSelector([selectSettings, selectWorkspace], (settings, workspace) => ({
  loading: settings?.loading,
  notificationSettingDetails: settings?.notificationSettingDetails,
  workspace: workspace?.workspace
}));

// Combined selectors for complex state
export const selectAppState = createSelector(
  [selectThemeMode, selectThemeType, selectWorkspaceData],
  (themeMode, themeType, workspace) => ({
    themeMode,
    themeType,
    workspace
  })
);
